export default __webpack_public_path__ + "static/media/pic104.7e9af857.jpg";